import moment from "moment";

const getLocalUIDateFormat = () => {
  const local = Intl.DateTimeFormat().resolvedOptions().locale;
  if (local === "en-GB") {
    return "DD-MM-YYYY";
  }
  if (local === "en-US") {
    return "MM-DD-YYYY";
  }
};

const getLocalAPIDateFormat = () => {
  const local = Intl.DateTimeFormat().resolvedOptions().locale;
  if (local === "en-GB") {
    return "DD MMMM YYYY";
  }
  if (local === "en-US") {
    return "MMMM D, YYYY";
  }
};

const getLocalAPIDateTimeFormat = () => {
  const local = Intl.DateTimeFormat().resolvedOptions().locale;
  if (local === "en-GB") {
    return "DD MMMM YYYY HH:mm:ss";
  }
  if (local === "en-US") {
    return "MMMM D, YYYY HH:mm:ss";
  }
};

const getLocalUIFileFormat = () => {
  const local = Intl.DateTimeFormat().resolvedOptions().locale;
  if (local === "en-GB") {
    return "DD-MM-YYYY-HH-mm-ss";
  }
  if (local === "en-US") {
    return "MM-DD-YYYY-HH-mm-ss";
  }
};

export const APIDateFormat = getLocalAPIDateFormat();
export const APIDateTimeFormat = getLocalAPIDateTimeFormat();
export const defaultFromDate = moment().subtract(1, "days").startOf("day");
export const UIDateFormat = getLocalUIDateFormat();
export const UIDateTimeFormat = " HH:mm";
export const ComplianceAPIDateFormat = "YYYY-MM-DD";
export const ComplianceUIDateTimeFormat = "YYYY-MM-DD HH:mm";
export const UITimeFormat = "HH:mm";
export const UIFileFormat = getLocalUIFileFormat();

export const mapPeriodsToSelect = (array) => {
  return array.map(({ name, fromDate, toDate }) => ({
    key: name,
    text: name,
    value: { fromDate, toDate },
  }));
};

export const getEventDate = (row) => {
  const fields = [
    row.customerInteraction?.interactionDate,
    row.observation?.observationDate,
    row.incident?.incidentDate,
    row.ageVerification?.ageVerificationDate,
    row.agcCheck?.timeChecked,
    row.dateCreated,
  ];

  for (const field of fields) {
    if (field) {
      return getFormattedDate(field);
    }
  }

  return "N/A";
};

export const getFormattedDate = (date) => {
  return moment(date).format(ComplianceUIDateTimeFormat);
};